import {Inject, Injectable} from '@angular/core';
import {StateService} from "@uirouter/core";
import {UIRouterGlobals} from '@uirouter/angular';
import * as _ from "lodash";

import {AppAlertService} from '../app-alert.service';
import {ParametersService} from '../parameters.service';
import {SendDataService} from '../send-data.service';
import {SubtitlesService} from '../subtitles.service';
import {
    ControlData,
    MenuElement,
    MenuElementType106,
    MenuElementType1_5, MenuElementType20,
    MenuElementType6,
    MenuElementType7, OneSwitchMenuElement,
    TwoSwitchTime
} from "../../models";
import {BehaviorSubject} from "rxjs";
import {DOCUMENT} from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class ControlService {
    private actualState: string = '';
    brotherElement: MenuElement[] | false | number = false;
    private centerHeight: number;
    code: string = '';
    comeFromControl: boolean = false;
    element = new BehaviorSubject<MenuElement | undefined>(undefined);
    element$ = this.element.asObservable();
    elementVal = new BehaviorSubject<MenuElement | undefined>(undefined);
    elementVal$ = this.elementVal.asObservable();
    fromMenu: boolean = false;
    hideMenu: boolean = false;
    overflow: boolean;
    pin: string = '';
    setsNewValue: number = 0;
    setTemp: MenuElement | 0 | undefined;
    template: number | string = '';
    time: TwoSwitchTime = {
        defaultHour: 0,
        defaultMinute: 0,
        hour: 0,
        maxHour: 0,
        maxTime: 0,
        minTime: 0,
        minute: 0,
    }
    tileControl: MenuElement | undefined;
    private wrapperHeight: number;
    dateStart: string;
    dateEnd: string;
    date: string;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private appAlert: AppAlertService,
        private parameters: ParametersService,
        private sendData: SendDataService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        private uiRouterGlobals: UIRouterGlobals,
    ) {
    }

    setColorByCompany(): string {
        if (this.parameters.urlCompany === 'klimor') return 'color-dark';
        return 'color-style';
    }

    setCheckboxIconByCompany(isSelected: boolean): string {
        if (isSelected && this.parameters.urlCompany === 'klimor') return 'control__checkbox-name--active-klimor';
        if (isSelected) return 'control__checkbox-name--active';
        return '';
    }

    setSelectBoxIconByCompany(isSelected: boolean): string {
        if (isSelected && this.parameters.urlCompany === 'klimor') return 'control__selectbox-name--active-klimor';
        if (isSelected) return 'control__selectbox-name--active';
        return '';
    }

    setControl(element: MenuElement): void {
        this.element.next(element);
        const elementVal = _.cloneDeep(element);
        elementVal.duringChange = elementVal.duringChange ? elementVal.duringChange : 'f';
        this.template = element.type;

        if (element.type === 1) {
            (elementVal as MenuElementType1_5).params.txtId = element.params.txtId === 1035 || element.params.txtId === 728 ? 1034 : element.params.txtId;
            (elementVal as MenuElementType1_5).params.format = 0;
        } else if (element.type === 2) {
            (elementVal as MenuElementType1_5).params.txtId = element.params.txtId === 1035 || element.params.txtId === 728 ? 1034 : element.params.txtId;
            (elementVal as MenuElementType1_5).params.format = 4;
        }
        this.elementVal.next(elementVal);

        if (this.uiRouterGlobals.current.name !== 'control') this.actualState = this.uiRouterGlobals.current.name;
        this.comeFromControl = true;
        this.$state.go('control', {selectedModuleHash: this.parameters.selectedModuleHash});
    };

    setOverflow(): void {
        setTimeout(() => {
            this.wrapperHeight = this.document.querySelector(".control__wrapper").getBoundingClientRect().height;
            this.centerHeight = this.document.querySelector(".center-xy").getBoundingClientRect().height;
            this.overflow = this.centerHeight - 90 < this.wrapperHeight;
        }, 0);
    };

    increaseVal(): void {
        const elementVal = this.elementVal.getValue() as (OneSwitchMenuElement  | MenuElementType7);
        let jump = 1;
        if (this.isUniversalValue(elementVal) && elementVal.params.jump !== 0) {
            jump = elementVal.params.jump;
        }
        const {value, max} = elementVal.params;
        elementVal.params.value = value + jump <= max ? value + jump : value;
        this.elementVal.next(elementVal);
    };

    reduceVal(): void {
        const elementVal = this.elementVal.getValue() as (OneSwitchMenuElement  | MenuElementType7);

        let jump = 1;
        if (this.isUniversalValue(elementVal) && elementVal.params.jump !== 0 ) {
            jump = elementVal.params.jump;
        }
        const {value, min} = elementVal.params;
        elementVal.params.value = value - jump >= min ? value - jump : value;
        this.elementVal.next(elementVal);
    };

    increaseTime(): void {
        const elementVal = this.elementVal.getValue() as MenuElementType7;
        const {timeValue, timeMax} = elementVal.params;
        elementVal.params.timeValue = timeValue + 1 <= timeMax ? timeValue + 1 : timeValue;
        this.elementVal.next(elementVal);
    }

    reduceTime(): void {
        const elementVal = this.elementVal.getValue() as MenuElementType7;
        const {timeValue, timeMin} = elementVal.params;
        elementVal.params.timeValue = timeValue - 1 >= timeMin ? timeValue - 1 : timeValue;
        this.elementVal.next(elementVal);
    }

    setTempTime(): void {
        const elementVal = this.elementVal.getValue() as MenuElementType7;
        const {value, timeValue, timeDefault} = elementVal.params;
        elementVal.params.value = value >= 0 ? value : elementVal.params.default;
        elementVal.params.timeValue = timeValue >= 0 ? timeValue : timeDefault;
        this.elementVal.next(elementVal);
    }

    setDefaultTempTime(): void {
        const elementVal = this.elementVal.getValue() as MenuElementType7;
        elementVal.params.value = elementVal.params.default;
        elementVal.params.timeValue = elementVal.params.timeDefault;
        this.elementVal.next(elementVal);
    }

    resetTempTime(): void {
        const elementVal = this.elementVal.getValue() as MenuElementType7;
        elementVal.params.value = -1;
        elementVal.params.timeValue = -1;
        this.elementVal.next(elementVal);
        this.returnTempTime();
    };

    returnTempTime(): void {
        const elementVal = this.elementVal.getValue() as MenuElementType7;
        const data = {
            temp: elementVal.params.value,
            time: elementVal.params.timeValue
        }

        this.returnVal(data);
    };

    hideControl(): void {
        if (this.fromMenu) {
            this.fromMenu = false;
        } else if (this.elementVal.getValue()) {
            this.tileControl = this.element.getValue();
        }
        this.hideMenu = false;
        this.elementVal.next(undefined);

        window.history.back();
    };

    validateCode(code: string): void {
        const elementVal = this.elementVal.getValue() as MenuElementType6;
        switch (elementVal.params.state) {
            case 0: {
                const regex = /^(\d{4,15})$/;

                if (regex.test(code)) {
                    elementVal.params['blockHide'] = 1;
                    this.returnVal(code);
                } else {
                    const message = `<div class="text-align-center">${this.subtitles.setSubtitle(4074)}</div>`;
                    this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(475), null, false, null);
                }
                break;
            }
            case 1:
            case 2:
                elementVal.params['blockHide'] = 1;
                this.returnVal(0);
                break;
            case 3:
            case 4:
                elementVal.params['blockHide'] = 1;
                this.returnVal("CONFIRM");
                break;
            default:
        }
        this.elementVal.next(elementVal);
    };

    returnVal(val: any): void {
        const elementVal = this.elementVal.getValue();
        let value = val;
        if (this.isUniversalValue(elementVal) && elementVal.params.jump) {
            value = val - (val % elementVal.params.jump);
        }
        this.code = '';

        const dataToSend: ControlData = {
            menuType: elementVal.menuType,
            ido: elementVal.id,
            data: {},
        };

        switch (elementVal.type) {
            case 6:
                dataToSend.data = {
                    code: value,
                }
                break
            case 20:
                dataToSend.data = {
                    value,
                    type: elementVal.params.type,
                }
                break
            case 7:
            case 31:
            case 109:
            case 120:
                dataToSend.data = val;
                break;
            default:
                dataToSend.data = {
                    value,
                }
        }

        if (this.pin) {
            dataToSend.data.pin = this.pin;
            this.pin = '';
        }

        this.sendData.sendControlData(dataToSend);

        if (!this.parameters.demoAccount()) {
            const element = this.element.getValue();
            element.params = elementVal.params;
            this.setsNewValue = elementVal.id;
            element.duringChange = 't';
            this.element.next(element);
            this.elementVal.next(elementVal);

            if (this.hasBlockHide(element)
                && element.params.blockHide !== undefined
                && element.params.blockHide === 1
            ) {
                this.setControl(element);
            } else {
                this.hideControl();
            }
        }
    };

    addControllerGroup(value: string): void {
        const regex = /^(\d{6,10})$/;
        let message = '<div class="text-align-center">';

        if (regex.test(value)) {
            const element = this.element.getValue();
            const elementVal = this.elementVal.getValue();
            element.params = elementVal.params;
            this.setsNewValue = elementVal.id;
            element.duringChange = 't';
            this.element.next(element);
            this.setControl(element);

            const data = JSON.stringify({params: value, ido: element.id});

            this.sendData.addControllerGroup(data).subscribe((response: any) => {
                const element = this.element.getValue();
                element.duringChange = 'f';
                this.element.next(element);
                this.setControl(element);

                if (response.correctGroup) {
                    const groupName = response.groupName;

                    if (response.added) {
                        message = `${this.subtitles.setSubtitle(4112)}: ${groupName}</div>`;
                    } else {
                        message = `${this.subtitles.setSubtitle(4113)}: ${groupName}`;
                    }
                } else {
                    message = `${this.subtitles.setSubtitle(4111)}</div>`;
                }
                this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(475), null, false, null);
            });
        } else {
            message = `${this.subtitles.setSubtitle(4111)}</div>`;
            this.appAlert.showAppAlert(message, this.subtitles.setSubtitle(475), null, false, null);
        }
    };

    private isUniversalValue(element: MenuElement): element is MenuElementType106 {
        return element.type === 106;
    }

    private hasBlockHide(element: MenuElement): element is MenuElementType6 | MenuElementType20 {
        return element.type === 20 || element.type === 6;
    }
}
